import { SubmittalSettlementsTable } from "../SubmittalSettlementsTable";
import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutReadyToSubmitSlideout extends Layout {
    layoutExcludedSubmittalSettlements: SubmittalSettlementsTable;
    layoutSubmittalSettlements: SubmittalSettlementsTable;
    sourceOrderPayables: DataSource;
}
